<!-- Inline -->
<div *ngIf="isInline; else default" class="custom-input-wrapper inline-input">
  <span class="inline-label">{{label}}</span>
  <input matInput [readonly]="isReadonly" (ngModel)="value" [ngModel]="getValue()" [disabled]="isDisabled" />
</div>

<!-- Default -->
<ng-template #default>
  <mat-form-field class="full-width">
    <mat-label>{{label}}</mat-label>
    <input matInput [readonly]="isReadonly" [(ngModel)]="value" [disabled]="isDisabled" />
  </mat-form-field>
</ng-template>
